<template>
  <div class="audio-upload-section text-center">
    <label class="audio-upload-button button text-center"
           :for="`audio-uploader-${attachmentOwnerId}`">
      <svg viewBox="0 -24 512.00046 512" class="sb-icon">
        <use xlink:href="#upload"></use>
      </svg>
      upload
    </label>

    <p class="error-label" v-if="errorMessage">{{errorMessage}}</p>

    <input :ref="`audioUpload${attachmentOwnerId}`"
           type="file"
           class="hide"
           :id="`audio-uploader-${attachmentOwnerId}`"
           accept=".wav,.aif,.aiff,.flac,.alac,.aac,.ogg,.mp3,.m4a,audio/mp3,audio/*;capture=microphone"
           @change="uploadAudio" />

    <small v-if="transcodeProgress">{{transcodeProgress}}</small>
  </div>
</template>

<script>
  import { createWorker } from '@ffmpeg/ffmpeg'

  export default {
    props: {
      attachmentOwnerId: [Number, String],
      maxMediaSize: [Number, String],
    },

    name: 'AudioUpload',

    data() {
      return {
        errorMessage: null,
        onlyAudio: [
          'audio/wav',
          'audio/x-wav',
          'audio/aif',
          'audio/x-aif',
          'audio/aiff',
          'audio/x-aiff',
          'audio/flac',
          'audio/x-flac',
          'audio/alac',
          'audio/x-alac',
          'audio/aac',
          'audio/x-aac',
          'audio/ogg',
          'audio/x-ogg',
          'audio/mp3',
          'audio/x-mp3',
          'audio/m4a',
          'audio/x-m4a',
          'audio/mpeg',
          'audio/MPA',
          'audio/mpa-robust'
        ],
        transcodeProgress: null,
        transcodeWorker: null,
      }
    },

    methods: {
      initFfmeg() {
        this.transcodeWorker = createWorker({
          progress: ({ ratio }) => {
            this.transcodeProgress = `Complete: ${(ratio * 100.0).toFixed(2)}%`
          },
        })
      },

      async transcodeAudio(file, name) {
        try {
          await this.transcodeWorker.load()
          await this.transcodeWorker.write(name, file)
          await this.transcodeWorker.transcode(name,  `${name}.mp4`)
          const { data } = await this.transcodeWorker.read(`${name}.mp4`),
            blob = new Blob([data.buffer], { type: 'video/mp4' }),
            fileName = name.substr(0, name.lastIndexOf("."))
          this.$emit('uploadMediaAttachment', blob, fileName)
        } catch (error) {
          const tryAgain = 'please try again or upload a different file'
          this.errorMessage = `error transcoding audio: ${error} - ${tryAgain}`
          this.$emit('setLoading', false)
        }
      },

      uploadAudio(event) {
        const files = event.target.files,
          file = files[0],
          name = file.name.replace(/\s/g , "-")

        if (!file) { return this.errorMessage = null }

        if (file.size < this.maxMediaSize) {
          if (!this.onlyAudio.includes(file.type)) {
            return this.errorMessage = `only audio files can be uploaded, file type selected: ${file.type}`
          }
          this.$emit('setLoading', true)
          this.errorMessage = null
          name && this.transcodeAudio(file, name)
        } else {
          this.errorMessage = 'audio file is too large, select an audio under 5mb'
          this.$refs[`audioUpload${this.attachmentOwnerId}`].value = null
        }
      },
    },

    created() {
      this.initFfmeg()
    },
  }
</script>